export const errorMessage = {
  InvalidCVV: 'Purchase Error: Invalid CVV',
  InvalidCVVShort: 'Invalid CVV',
  ExpiredCard: 'Purchase Error: Expired Card',
  ExpiredDateCard: 'Purchase Error: Expiry Date Card',
  Decline: 'Purchase Error: Decline',
  CardInvalid: 'Purchase Error: Card Invalid',
  InvalidCVV2: 'Purchase Error: CVV2 Value supplied is invalid',
  InvalidCVV2Short: 'CVV2 Value supplied is invalid',
};
